import { render, staticRenderFns } from "./WaterFlowComponent.vue?vue&type=template&id=15e8c2c2&scoped=true&"
import script from "./WaterFlowComponent.vue?vue&type=script&lang=js&"
export * from "./WaterFlowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8c2c2",
  null
  
)

export default component.exports